import { ExclamationTriangleIcon } from '@radix-ui/react-icons';

type BackendRateError = {
  path: string[];
  attribute: string;
  code: string;
  message: string;
};

export const TEXT_PLACEHOLDER = '--';

function formattedPathAndMessage(error: BackendRateError): [string, string] {
  const entityPath = error.path.slice(0, -1).join(' -> '); // Exclude the last part (attribute)
  let { message } = error;

  if (error.attribute !== '') {
    message = `'${error.attribute}' is required`;
  }

  return [entityPath, message];
}

export const getCleanText = (input: string | unknown) => {
  if (typeof input === 'string' && input.trim()) {
    return input;
  }
  return TEXT_PLACEHOLDER;
};

export const formatErrorMessage = (error: any) => {
  try {
    if (error.errors && Array.isArray(error.errors)) {
      return (
        <div className="space-y-4">
          {error.errors.map((err: BackendRateError, idx: number) => {
            const [entityPath, message] = formattedPathAndMessage(err);
            return (
              <div
                key={idx}
                className="flex items-start gap-3 rounded-lg bg-red-50 p-3"
              >
                <ExclamationTriangleIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-red-500" />
                <div>
                  <p className="font-medium text-red-700">{entityPath}</p>
                  <p className="text-red-600">{message}</p>
                </div>
              </div>
            );
          })}
        </div>
      );
    }

    const errorDetail = error.detail;

    if (!errorDetail.includes('messages=[') && errorDetail.includes('Error(')) {
      const errorsStr = errorDetail.split(':')[1].trim();
      const errors = errorsStr
        .slice(1, -1)
        .split('), Error(')
        .map((err: any) => {
          const messageMatch = err.match(/message='([^']+)'/);
          return {
            message: messageMatch ? messageMatch[1] : '',
          };
        });

      return (
        <div className="space-y-4">
          {errors.map((err: any, idx: any) => (
            <div
              key={idx}
              className="flex items-start gap-3 rounded-lg bg-red-50 p-3"
            >
              <ExclamationTriangleIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-red-500" />
              <div>
                <p className="font-medium text-red-700">{err.message}</p>
              </div>
            </div>
          ))}
        </div>
      );
    }
    // Generic Error
    return (
      <div className="flex items-start gap-3 rounded-lg bg-red-50 p-3">
        <ExclamationTriangleIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-red-500" />
        <pre className="font-medium text-red-700">{errorDetail}</pre>
      </div>
    );
  } catch (e) {
    return error.detail || error.toString();
  }
};
